import { render, staticRenderFns } from "./permissioner.vue?vue&type=template&id=5f31fe02&"
import script from "./permissioner.vue?vue&type=script&lang=js&"
export * from "./permissioner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports